/* eslint-disable react-hooks/exhaustive-deps */
/**
 * @author viaud Benjamin
 * @copyright Horizon-Pharma
 */

import React, { useEffect, useState, useContext, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';

import { Button, Table, Select, Input, DatePicker, InputNumber, Switch } from 'antd';
import { CloseCircleFilled, HolderOutlined, SaveFilled } from '@ant-design/icons';

import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import local from 'antd/es/date-picker/locale/fr_FR';

import Container from '../../components/atoms/Container/container';
import { GET, POST } from '../../components/Utils/requete';

import { testDroit } from '../../components/Utils/testDroit';
import { Paramétre } from '../../fonctionsRoles/accesURL';
import formatSelect from '../../components/Utils/FormatSelect';

const RowContext = React.createContext({});
const DragHandle = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext);
    return <Button type="text" size="small" icon={<HolderOutlined />} style={{ cursor: 'move' }} ref={setActivatorNodeRef} {...listeners} />;
};

const Row = (props) => {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id: props['data-row-key'] });
    const style = Object.assign(
        Object.assign(Object.assign({}, props.style), {
            transform: CSS.Translate.toString(transform),
            transition,
        }),
        isDragging ? { position: 'relative', zIndex: 9999 } : {},
    );
    const contextValue = useMemo(() => ({ setActivatorNodeRef, listeners }), [setActivatorNodeRef, listeners]);
    return (
        <RowContext.Provider value={contextValue}>
            <tr {...props} ref={setNodeRef} style={style} {...attributes} />
        </RowContext.Provider>
    );
};

const { TextArea } = Input;
const ListesParametres = (props) => {
    const user = useSelector((state) => state.Utilisateur);
    const usurpation = user.userC;
    const [data, setData] = useState([]);
    const [dataRequete, setDataRequete] = useState([]);
    const [listeCategorie, setListeCategorie] = useState([]);
    const [disabledSave, setDisabledSave] = useState();
    const [categorie, setCategorie] = useState('');

    function updateChamps(keys, valueI, index) {
        if (disabledSave === undefined) {
            setDisabledSave(index);
        } else if (disabledSave === index && dataRequete[index].valeur === valueI) {
            setDisabledSave();
        } else if (disabledSave !== index) {
            return props.notification({ message: "Vous devez finir l'operation en cours" });
        }
        const creationNouvelleReference = [];
        for (let elem = 0; elem < data.length; elem++) {
            creationNouvelleReference.push({});
            Object.assign(creationNouvelleReference[elem], data[elem]);
            if (elem === +index) {
                creationNouvelleReference[elem][keys] = valueI;
            }
        }
        setData(creationNouvelleReference);
    }

    async function getCategorie() {
        const response = await GET('/api/parametres/listCategorie');
        setListeCategorie(response.data);
    }
    console.log(data);
    async function recupParametre() {
        let query = '/api/parametres/list';
        if (categorie) query = query + `?categorie=${categorie}`;
        console.log(query);
        const response = await GET(query);
        setData(response.data);
        setDataRequete(response.data);
    }
    function CelluleValeur(props, index) {
        switch (props.type) {
            case 'input':
                return <Input value={props.valeur} className="nomargin" onChange={(e) => updateChamps('valeur', e.target.value, index)} />;

            case 'integer':
                return <InputNumber className="nomargin" value={props.valeur} onChange={(value) => updateChamps('valeur', value, index)} />;
            case 'date':
                return (
                    <DatePicker
                        value={dayjs(props.valeur.split('/').reverse().join('-'))}
                        format={'DD/MM/YYYY'}
                        locale={local}
                        onChange={(dates, dateStrings) => updateChamps('valeur', dateStrings.split('-').reverse().join('-'), index)}
                    />
                );
            case 'select':
                const array = formatSelect(props.valeursPossibles, 'id', 'libelle');
                return (
                    <Select
                        value={typeof array[0].value === 'number' ? +props.valeur : props.valeur}
                        className="w90"
                        options={array}
                        onChange={(value) => updateChamps('valeur', value, index)}
                    />
                );
            case 'textarea':
                return <TextArea rows={3} value={props.valeur} onChange={({ target }) => updateChamps('valeur', target.value, index)} />;
            case 'boolean':
                return <Switch checked={+props.valeur === 0 ? false : true} onChange={() => updateChamps('valeur', +props.valeur === 1 ? 0 : 1, index)} />;
            default:
                return <></>;
        }
    }
    async function updateBDD(index) {
        const dataRequete = {
            cle: data[index].cle,
            valeur: data[index].valeur,
            categorie: data[index].categorie,
        };
        await POST('/api/parametres/save', dataRequete);
        recupParametre();
        setDisabledSave();
    }
    async function moveOrdre(data, newOrdre, oldOrdre) {
        const dataRequete = {
            cle: data.cle,
            categorie: data.categorie,
            keyArray: newOrdre,
            oldOrdre: oldOrdre,
        };
        console.log(dataRequete);
        await POST('/api/parametres/moveOrdre', dataRequete);
        recupParametre();
    }
    const onDragEnd = ({ active, over }) => {
        if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
            setData((prevState) => {
                const activeIndex = prevState.findIndex((record) => record.key === (active === null || active === void 0 ? void 0 : active.id));
                const overIndex = prevState.findIndex((record) => record.key === (over === null || over === void 0 ? void 0 : over.id));
                moveOrdre(data[activeIndex], over.id, active.id);
                return arrayMove(prevState, activeIndex, overIndex);
            });
        }
    };
    useEffect(() => {
        props.addNomPage('Paramètres');
        recupParametre();
        getCategorie();
    }, [categorie]);

    useEffect(() => {
        getCategorie();
    }, []);
    const columns = [
        {
            title: 'Operation',
            render: (text, props, index) => (
                <>
                    <div className="flex flex-col">
                        <SaveFilled
                            className={'fontSize1_5em mr2 '.concat(disabledSave !== index ? 'cGray' : 'cBleu2c70c6')}
                            onClick={() => disabledSave && disabledSave === index && updateBDD(index)}
                        />
                        <CloseCircleFilled
                            onClick={() => {
                                setDisabledSave();
                                setData(dataRequete);
                            }}
                            className="fontSize1_5em  cRed"
                            style={disabledSave !== index ? { display: 'none' } : null}
                        />
                    </div>
                </>
            ),
            width: '2em',
        },
        { title: 'Categorie', dataIndex: 'categorie', width: '4em' },
        { title: 'Cle', dataIndex: 'cle', width: '6em' },
        {
            title: 'Valeur',
            render: (text, props, index) => CelluleValeur(props, index),
            width: '10em',
        },
        { title: 'Commentaire', dataIndex: 'commentaire', width: '10em' },
    ];
    if (categorie) columns.unshift({ key: 'sort', align: 'center', width: '2em', render: () => <DragHandle /> });

    if (window.matchMedia('(max-width: 576px)').matches) {
        return <p className="textCenter ">Vous ne pouvez pas gérer les paramètres sur mobile</p>;
    }
    if (window.matchMedia('(max-width: 576px)').matches || window.matchMedia('(max-width: 1080px)').matches) {
        return <p className="textCenter ">Vous ne pouvez pas accéder à cette page sur mobile</p>;
    }
    if (!testDroit(user[usurpation].roleFonction, Paramétre)) return window.location.replace('/role-erreur');
    return (
        <div className="listeContainer">
            <Container>
                <div className="flex directionColumn">
                    <label>Catégorie des paramètres</label>
                    <Select
                        value={categorie}
                        className="w40 mb2 mt1"
                        options={formatSelect(listeCategorie, 'categorie', 'categorie', 'TOUTE LES CATEGORIES')}
                        onChange={(value) => setCategorie(value)}
                    />
                </div>
                <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
                    <SortableContext items={data.map((i) => i.key)} strategy={verticalListSortingStrategy}>
                        <Table
                            rowKey="key"
                            components={{ body: { row: Row } }}
                            columns={columns}
                            dataSource={data}
                            pagination={{
                                position: [],
                                total: data.length,
                                defaultPageSize: data.length,
                            }}
                        />
                    </SortableContext>
                </DndContext>
            </Container>
        </div>
    );
};
function mapDispatchToProps(dispatch) {
    return {
        addNomPage(nomPage) {
            dispatch({ type: 'stock', nomPage });
        },
        notification(note) {
            dispatch({ type: 'notification', note });
        },
    };
}

export default connect(null, mapDispatchToProps)(ListesParametres);
